import { z } from 'zod';

const envSchema = z.object({
  VITE_API_URL: z.url('VITE_API_URL must be a valid URL'),
  USE_HTTPS: z
    .string()
    .transform((val) => val === 'true')
    .pipe(z.boolean())
    .optional(),
  MODE: z.enum(['development', 'production', 'test']).optional(),
  DEV: z.boolean().optional(),
  PROD: z.boolean().optional(),
});

export function validateEnv(): z.infer<typeof envSchema> {
  const result = envSchema.safeParse(import.meta.env);

  if (!result.success) {
    console.error(z.treeifyError(result.error).properties);
    throw new Error(`Invalid environment variables: ${z.treeifyError(result.error)}`);
  }

  return result.data;
}

export const env = validateEnv();

export type Env = z.infer<typeof envSchema>;
